import React from 'react';
import Client from 'shopify-buy';
import './App.css';
import ProductList from "./ProductList";
import ProductDetail from "./components/ProductDetailPage";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import {ProductProvider} from "./components/products/productsContext"
import CartDetails from './components/CartDetails';

Client.buildClient({
  domain: 'blue-lion-apparel-llc.myshopify.com',
  storefrontAccessToken: '34acd07c5cbc899e721d17d94b11b2c6'
});

const App = () => { 
    return (
      <ProductProvider>
        <CartDetails />
        <Router>
         <Switch>
           <Route exact path="/merch2" component={ProductList} />
           <Route path="/merch/collection" component={ProductList} />
           {/* <Route path="/ProductDetail/:category/:id" component={ProductDetail} /> */}
           <Route path="/ProductDetail/:category" component={ProductDetail} />
         </Switch>
       </Router>
      </ProductProvider>    
    );
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js